import MainLayout from "../../../layouts/MainLayout";
import { Container, Row, Col, Card, CardBody, CardTitle } from 'reactstrap';
import { FaWhatsapp, FaFileAlt, FaCertificate, FaCheckCircle, FaUsers, FaBolt, FaShieldAlt } from 'react-icons/fa';
import './styles.css';
import DefaultButton from "../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";

function PropertyEvaluationPage() {
  const { t } = useTranslation();
  const whatsappNumber = "96555144330";
  
  const handleGuideEvaluation = () => {
    const message = encodeURIComponent("مرحباً، أرغب في الحصول على تقييم استرشادي لعقاري");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };
  
  const handleCertifiedEvaluation = () => {
    const message = encodeURIComponent("مرحباً، أرغب في الحصول على تقييم معتمد لعقاري");
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <MainLayout>
      <Container className="py-4">
        <div className="text-center mb-5">
          <h1 className="display-4 fw-bold text-dark mb-3">
            { t('property_evaluation.title') }
          </h1>
          <p className="lead text-muted">
            { t('property_evaluation.subtitle') }
          </p>
        </div>

        <Row className="mb-5 g-4">
          <Col md={6}>
            <Card className="evaluation-card guide-card border-0 h-100">
              <div className="card-header-custom bg-primary">
                <div className="icon-circle mx-auto mb-3">
                  <FaFileAlt size={32} />
                </div>
                <CardTitle tag="h2" className="text-white text-center mb-0">
                  { t('property_evaluation.indicative.title') }
                </CardTitle>
              </div>
              
              <CardBody className="p-4">
                <ul className="features-list mb-4">
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.indicative.options.1') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.indicative.options.2') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.indicative.options.3') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.indicative.options.4') }</span>
                  </li>
                </ul>
                
                <DefaultButton
                  color="primary"
                  size="lg"
                  block
                  onClick={handleGuideEvaluation}
                  className="whatsapp-btn d-flex align-items-center justify-content-center gap-2"
                  style={{background: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)'}}
                >
                  <FaWhatsapp size={24} />
                  <span>{ t('property_evaluation.indicative.button') }</span>
                </DefaultButton>
              </CardBody>
            </Card>
          </Col>

          <Col md={6}>
            <Card className="evaluation-card certified-card border-0 h-100 position-relative">
              <div className="recommended-badge">
                { t('property_evaluation.certified.recommended') }
              </div>
              <div className="card-header-custom bg-success">
                <div className="icon-circle mx-auto mb-3">
                  <FaCertificate size={32} />
                </div>
                <CardTitle tag="h2" className="text-white text-center mb-0">
                  { t('property_evaluation.certified.title') }
                </CardTitle>
              </div>
              
              <CardBody className="p-4">
                <ul className="features-list mb-4">
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.certified.options.1') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.certified.options.2') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.certified.options.3') }</span>
                  </li>
                  <li>
                    <FaCheckCircle className="text-success me-2" />
                    <span>{ t('property_evaluation.certified.options.4') }</span>
                  </li>
                </ul>
                
                <DefaultButton
                  color="success"
                  size="lg"
                  block
                  onClick={handleCertifiedEvaluation}
                  className="whatsapp-btn d-flex align-items-center justify-content-center gap-2"
                >
                  <FaWhatsapp size={24} />
                  <span>{ t('property_evaluation.certified.button') }</span>
                </DefaultButton>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <Card className="border-0">
          <CardBody className="p-5 text-center">
            <h3 className="h2 fw-bold text-dark mb-4">
              { t('property_evaluation.features.title') }
            </h3>
            <Row className="mt-4 g-4">
              <Col md={4}>
                <div className="feature-box">
                  <div className="feature-icon bg-primary bg-opacity-10 mx-auto mb-3">
                    <FaUsers size={32} className="text-white" />
                  </div>
                  <h4 className="fw-bold text-dark mb-2">{ t('property_evaluation.features.1.title') }</h4>
                  <p className="text-muted">{ t('property_evaluation.features.1.description') }</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="feature-box">
                  <div className="feature-icon bg-success bg-opacity-10 mx-auto mb-3">
                    <FaBolt size={32} className="text-white" />
                  </div>
                  <h4 className="fw-bold text-dark mb-2">{ t('property_evaluation.features.2.title') }</h4>
                  <p className="text-muted">{ t('property_evaluation.features.2.description') }</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="feature-box">
                  <div className="feature-icon bg-info bg-opacity-10 mx-auto mb-3">
                    <FaShieldAlt size={32} className="text-white" />
                  </div>
                  <h4 className="fw-bold text-dark mb-2">{ t('property_evaluation.features.3.title') }</h4>
                  <p className="text-muted">{ t('property_evaluation.features.3.description') }</p>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </MainLayout>
  );
}

export default PropertyEvaluationPage;